import React from 'react';
import '../index.css';
import '../output.css';
import { TypeAnimation } from 'react-type-animation';

import WideYork from "../assets/images/widenychart.png"; // Adjust the path if needed

import { useState, useEffect } from 'react';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile(); // Check on mount

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function Announcement(){

  const isMobile = useIsMobile();

  if (isMobile) {
    return (

        <div style={{ width: "100%", overflow: "hidden" }}>
    <div
      style={{
        marginBottom: "0px",
        paddingTop: "24px",
        paddingLeft: "16px",
        paddingRight: "16px",
      }}
    >
    <div
  style={{
    marginTop: "24px",
    fontSize: "20px",
    lineHeight: "1.15",
    textAlign: "center",
    width: "100%",
    maxWidth: "100%",
    color: "inherit",
  }}
>
  <TypeAnimation
    className="font-bold"
    sequence={[
      "We're building the lending market for 60601",
      1000,
      "We're building the lending market for 94105",
      1000,
      "We're building the lending market for 10001",
      1000,
      "We're building the lending market for 02110",
      1000,
      "We're building the lending market for 90210",
      1000,
      "We're building the lending market for 85032",
      1000,
      "We're building the lending market for 48202",
      1000,
      "We're building the lending market for 19130",
      1000,
      "We're building the lending market for 77020",
      1000,
      "We're building the lending market for 08648",
      1000,
      "We're building the lending market for 30312",
      1000,
      "We're building the lending market for 55402",
      1000,
      "We're building the lending market for 15282",
      1000,
      "We're building the lending market for everywhere",
      1000,
      "We're building the lending market for everybody",
      1000,
      "We're building the lending market for you.",
      5000,
    ]}
    speed={50}
    deletionSpeed={75}
    repeat={Infinity}
    style={{
      fontSize: "inherit",
      lineHeight: "inherit",
      display: "block",
      width: "100%",
    }}
  />
</div>
    </div>

    <img
      src={WideYork}
      alt="Wide York"
      style={{
        width: "100%",
        height: "auto",
        objectFit: "cover",
        display: "block",
        marginTop: "20px",
      }}
    />
  </div>
    )
  } else {
  return(
    <div>
    <div style={{marginBottom: "0px", paddingTop: "50px"}}>
    <TypeAnimation className="font-bold"
  sequence={[

//maybe try this with zipcodes?

      // Same substring at the start will only be typed once, initially
      "We're building a peer-to-peer lending market for 60601",
      1000,
      "We're building a peer-to-peer lending market for 94105",
      1000,
      "We're building a peer-to-peer lending market for 10001",
      1000,
      "We're building a peer-to-peer lending market for 02110",
      1000,
      "We're building a peer-to-peer lending market for 90210",
      1000,
      "We're building a peer-to-peer lending market for 85032",
      1000,
      "We're building a peer-to-peer lending market for 48202",
      1000,
      "We're building a peer-to-peer lending market for 19130",
      1000,
      "We're building a peer-to-peer lending market for 77020",
      1000,
      "We're building a peer-to-peer lending market for 08648",
      1000,
      "We're building a peer-to-peer lending market for 30312",
      1000,
      "We're building a peer-to-peer lending market for 55402",
      1000,
      "We're building a peer-to-peer lending market for 15282",
      1000,
      "We're building a peer-to-peer lending market for everywhere",
      1000,
      "We're building a peer-to-peer lending market for everybody",
      1000,
      "We're building a peer-to-peer lending market for you.",
      5000,
    ]}
  speed={50}
  deletionSpeed={75}
  style={{marginTop: "70px", fontSize: "56px", objectFit: "contain", justifyContent: "center", display: 'flex'}}
  repeat={Infinity}
/>
</div>
  <img
  src={WideYork}
  style={{objectFit: "cover"}}
  />
</div>
  )
}
}
